<div class="page">

  <div class="header">
    <div class="titleClock">
      <h1 class="text-nowrap">IMPORTADOR</h1>
    </div>

    <div class="d-flex align-items-center gap-2">
      <button class="btn btnOrange" (click)="importar()" tooltip="Importar">
        <img src="assets/img/icoImportar.svg" style="height: 18px;">
        IMPORTAR
      </button>
    </div>
  </div>

  <div class="boxWhite">
    <div class="headBox">
      <div class="filtros">
        <div class="fecha itemForm">
          <input type="text" class="form-control" placeholder="TODAS LAS FECHAS" bsDatepicker
            (bsValueChange)="onChangeFecha($event)" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
            [bsValue]="fechaSeleccionada">
        </div>
      </div>

      <div class="d-flex align-items-center gap-2">
        <span class="clGray" style="font-size: 12px;">
          {{registros.length}} REGISTRO{{registros.length !== 1 ? 'S' : ''}}
        </span>
      </div>
    </div>

    <div class="tableResp">
      <div *ngIf="cargando" class="text-center py-5">
        <span class="clGray" style="font-size: 14px;">CARGANDO...</span>
      </div>

      <table class="table" *ngIf="!cargando">
        <thead>
          <tr>
            <th [tooltip]="'ID del registro'" placement="bottom" container="body">#</th>
            <th *ngFor="let col of columnas" [tooltip]="formatHeader(col)" placement="bottom" container="body">{{formatHeader(col)}}</th>
            <th [tooltip]="'Acciones del registro'" placement="bottom" container="body">ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="registrosFiltrados.length === 0">
            <td [attr.colspan]="columnas.length + 2" style="text-align: center; padding: 40px; color: var(--gray);">
              SIN DATOS PARA ESTA FECHA
            </td>
          </tr>
          <tr *ngFor="let registro of registrosFiltrados">
            <td>{{registro.id || '-'}}</td>
            <td *ngFor="let col of columnas"
                [tooltip]="col === 'estado' ? registro['mensajeError'] : null"
                placement="bottom" container="body">
              <span *ngIf="col === 'origen' && registro[col]; else valorCelda" class="tagOrigen" [ngClass]="claseOrigen(registro[col])">{{formatValue(registro[col])}}</span>
              <ng-template #valorCelda>{{formatValue(registro[col])}}</ng-template>
            </td>
            <td>
              <div class="btns">
                <button class="btn btnSmIcon" (click)="verLogs(registro)" tooltip="Ver logs">
                  <img src="assets/img/icoLogs.svg">
                </button>
                <button class="btn btnCancelar" *ngIf="!esFechaPasada() && puedeEliminar(registro)" (click)="confirmarEliminar(registro)" tooltip="Eliminar">
                  <img src="assets/img/icoDelete.svg">
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="paginacion" *ngIf="totalPages > 1">
      <button class="btn btnGray" [disabled]="page === 0" (click)="paginaAnterior()">
        ANTERIOR
      </button>
      <span>PÁGINA {{page + 1}} DE {{totalPages}}</span>
      <button class="btn btnGray" [disabled]="page >= totalPages - 1" (click)="paginaSiguiente()">
        SIGUIENTE
      </button>
    </div>
  </div>
</div>

<div class="modalOverlay" *ngIf="registroPendienteBorrar" (click)="cancelarEliminar()">
  <div class="modalConfirm" (click)="$event.stopPropagation()">
    <h4>ELIMINAR REGISTRO</h4>
    <p>¿Está seguro que desea eliminar este registro?</p>
    <div class="modalBtns">
      <button class="btn btnGray" (click)="cancelarEliminar()">CANCELAR</button>
      <button class="btn btnRed" (click)="eliminar()">SÍ, ELIMINAR</button>
    </div>
  </div>
</div>
